import { marqueeItems } from "@/mocks/hotlist";

export default function Ticker() {
  const doubled = [...marqueeItems, ...marqueeItems];
  return (
    <div className="relative z-10 flex items-center overflow-hidden border-b border-primary-800 bg-primary-600 text-background-50">
      <div className="relative z-10 flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-2.5">
        <i className="ri-fire-fill animate-pulse"></i>
        <span className="text-xs font-semibold">正在热</span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden">
        <div className="flex animate-marquee items-center whitespace-nowrap">
          {doubled.map((item, idx) => (
            <span key={idx} className="mx-6 inline-flex items-center gap-2 text-sm text-background-100/95">
              <i className="ri-arrow-right-s-line text-secondary-300"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}